export default __webpack_public_path__ + "static/media/1286.9dcf8e55.png";